import React, { Component } from 'react';
import Breadcrumb from '../../Breadcrumb';
import moment from 'moment/moment';
import { FormicaProps, withFormica } from '../../../helpers/withFormica';
import { store } from '../../../redux/store';
import { initialPagePath } from '../../../redux/reducers/PageReducer';
import ComponentName from '../../../constant/ComponentName';
import FolderService from '../../../service/FolderService';
import Icon from '../../../icons/Icon';
import LanguageUtil from '../../../util/LanguageUtil';
import WatchlistSafeListTableComponent from './WatchlistSafeListTableComponent';
import WatchlistService from '../../../service/WatchlistService';
import ServiceContainer from '../../../config/ServiceContainer';
import { ServiceNames } from '../../../constant/ServiceNames';
import {
  SafeListTableRow,
  WatchlistBaseModel,
  WatchlistEntityRequest,
  WatchlistGeneralRequest,
  WatchlistIndividualRequest,
} from '../../../domain/watchlist/WatchlistDomains';
import { WatchlistType } from '../../../constant/Constants';
import MessageUtil from '../../../util/MessageUtil';
import CustomLoading from '../../custom/CustomLoading';
import SafeListPubSub, { SafeListPubSubMessage } from '../../../util/SafeListPubSub';
import WatchlistUtil from '../../../util/WatchlistUtil';
import WatchlistSearchCriteriaModalComponent from '../detail/modal/WatchlistSearchCriteriaModalComponent';
import NavigationUtil from '../../../util/NavigationUtil';
import ValueUtil from '../../../util/ValueUtil';
import { ProgressSpinner } from 'primereact/progressspinner';
import { Tooltip } from 'primereact/tooltip';
import { generateUUIDV4 } from '../../../util/Generator';

class WatchlistSafeListLinkComponent extends Component<Props, State> {
  public state: State = new State();
  private watchlistService: WatchlistService = ServiceContainer.getInstance().get(ServiceNames.WATCHLIST);
  private unsubscribeSafeListPubSub: (() => void) | undefined;
  private revalidateTimeoutId: ReturnType<typeof setTimeout> | undefined;
  private activeReferenceId: string | null = null;
  private safeListLoadToken: number = 0;
  private readonly removeTooltipTargetClass = `safe-list-remove_${generateUUIDV4()}`;
  private static readonly REVALIDATE_DELAY_MS = 800;

  public render() {
    const { date, name, loading, rows, selectedRows, removeLoading, searchCriteriaVisible, request } = this.state;
    return (
      <div className='w-full h-full flex flex-col overflow-hidden'>
        <div className={'shrink-0'}>
          <Breadcrumb />
        </div>
        <div className={'p-5 shrink-0'}>
          <div className={'flex justify-between'}>
            <div className={'flex'}>
              <span
                key={'icon'}
                className='w-[60px] h-[60px] min-h-[60px] min-w-[60px] 2xl:w-[80px] 2xl:h-[80px] 2xl:min-h-[80px] 2xl:min-w-[80px] flex justify-center items-center rounded-[50%] bg-[#EFF2FE] mr-1'
              >
                <Icon icon={'safe-list'} className={'text-[#728EFF] fill-[#728EFF]'} color={'#728EFF'} size={32} />
              </span>
              <div className={'flex flex-col justify-center pl-3'}>
                <span className={'text-[24px] 2xl:text-4xl font-normal'}>
                  {name || LanguageUtil.get({ id: 'pages.watchlist.safeListTitle', defaultMessage: 'Safe List' })}
                </span>
                <div className={'flex items-center gap-x-2'}>
                  <span
                    className={`flex text-xs shrink-0 2xl:text-md h-full justify-center items-center px-[8px] py-[3px] rounded-[50px] bg-[#F6F6F9] text-[#4F4F4F]`}
                  >
                    {date}
                  </span>
                  <div className={'flex gap-x-1 cursor-pointer'} onClick={() => this.setState({ searchCriteriaVisible: true })}>
                    <span className={'text-[14px] underline text-normal text-[#458EF7]'}>
                      {LanguageUtil.get({ id: 'common.label.searchCriteria', defaultMessage: 'Search Criteria' })}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className={'px-5 text-f-black-2 text-[13px] flex items-center gap-x-1 shrink-0'}>
          <Icon icon={'visibility'} size={14} color={'#728EFF'} />
          <span>
            {LanguageUtil.get({
              id: 'pages.watchlist.safeListPageDescription',
              defaultMessage: 'You can review the records you have added to the safe list below.',
            })}
          </span>
        </div>
        <div className={'px-5 pt-9 pb-2 flex-1 min-h-0 w-full flex flex-col overflow-hidden'}>
          {loading ? (
            <CustomLoading />
          ) : (
            <>
              <div className={'relative h-0 w-full z-10 shrink-0'}>
                {selectedRows.length > 0 && (
                  <div className={'absolute right-0 bottom-2 flex items-center'}>
                    <Tooltip position='left' target={`.${this.removeTooltipTargetClass}`}>
                      {LanguageUtil.get({ id: 'pages.watchlist.removeFromSafeList', defaultMessage: 'Remove from Safe List' })}
                    </Tooltip>
                    <a
                      className={`cursor-pointer relative group border rounded border-[#E0E4E8] w-[28px] h-[28px] flex items-center justify-center bg-white-1 hover:bg-f-gray active:bg-[#458EF714] active:border-[#458EF7] ${this.removeTooltipTargetClass}`}
                      onClick={(e) => {
                        e.stopPropagation();
                        e.preventDefault();
                        if (removeLoading) {
                          return;
                        }
                        this.onRemove();
                      }}
                    >
                      {removeLoading ? (
                        <ProgressSpinner style={{ height: '60%', width: '60%' }} />
                      ) : (
                        <Icon
                          icon={'remove-from-list'}
                          size={18}
                          color={'#4F4F4F'}
                          className={'group-hover:text-primary hover:cursor-pointer flex items-center justify-center'}
                        />
                      )}
                    </a>
                  </div>
                )}
              </div>
              <div className={'flex-1 min-h-0 overflow-hidden'}>
                <WatchlistSafeListTableComponent
                  rows={rows}
                  loading={false}
                  selectedRows={selectedRows}
                  onSelectionChange={this.onSelectionChange}
                  onRowClick={this.onRowClickDetail}
                />
              </div>
            </>
          )}
        </div>
        <WatchlistSearchCriteriaModalComponent
          visible={searchCriteriaVisible}
          request={request}
          onClose={() => this.setState({ searchCriteriaVisible: false })}
        />
      </div>
    );
  }

  public async componentDidMount() {
    const { router } = this.props;
    const page = store.getState().page;
    const initial = initialPagePath[ComponentName.WATCHLIST];
    if (page.pagePath.length == 0 || page.pagePath[0].title != initial?.title) {
      await FolderService.calculate('WITHOUT_FOLDER', ComponentName.WATCHLIST, router.location.pathname, store.getState().page);
    }
    const previousSearchParams = new URLSearchParams(router.params.id);
    const name: string | null = previousSearchParams.get('name');
    const referenceId: string | null = previousSearchParams.get('referenceId');
    const type: string | null = previousSearchParams.get('type');
    const request = this.getRequestModel();
    this.activeReferenceId = referenceId;
    this.setState({
      name: name,
      referenceId: referenceId,
      type: (type as WatchlistType) || 'General',
      request,
      date: moment().format('DD/MM/yyyy HH:mm').valueOf(),
    });

    this.unsubscribeSafeListPubSub = SafeListPubSub.subscribe((message) => {
      if (this.activeReferenceId == undefined || this.activeReferenceId == null) return;
      if (message.referenceId !== this.activeReferenceId) return;
      this.applySafeListPubSubMessage(message);
    });

    await this.loadSafeList(referenceId, (type as WatchlistType) || 'General', true);
  }

  public componentWillUnmount() {
    if (this.unsubscribeSafeListPubSub) {
      this.unsubscribeSafeListPubSub();
      this.unsubscribeSafeListPubSub = undefined;
    }
    if (this.revalidateTimeoutId != undefined) {
      clearTimeout(this.revalidateTimeoutId);
      this.revalidateTimeoutId = undefined;
    }
  }

  private applySafeListPubSubMessage = (message: SafeListPubSubMessage) => {
    switch (message.action) {
      case 'add':
        this.setState((prevState) => {
          const existingIds = new Set(prevState.rows.map((row) => row.consolidatedRecordId));
          const rowsToAdd = message.records
            .filter((record) => !existingIds.has(record.record.id))
            .map((record) => ({
              consolidatedRecordId: record.record.id,
              record: { ...record, isSafeListed: true },
            }));
          const rows = [...prevState.rows, ...rowsToAdd]
            .map((row) => row.record)
            .filter((record): record is WatchlistBaseModel => record != null)
            .sort((a, b) => b.score - a.score)
            .map((record) => ({
              consolidatedRecordId: record.record.id,
              record,
            }));
          return { rows };
        });
        break;
      case 'remove': {
        const removedIds = new Set(message.records.map((record) => record.record.id));
        this.setState((prevState) => ({
          rows: prevState.rows.filter((row) => !removedIds.has(row.consolidatedRecordId)),
          selectedRows: prevState.selectedRows.filter((row) => !removedIds.has(row.consolidatedRecordId)),
        }));
        break;
      }
      default:
        break;
    }
    this.scheduleRevalidate();
  };

  private scheduleRevalidate = () => {
    if (this.revalidateTimeoutId != undefined) {
      clearTimeout(this.revalidateTimeoutId);
    }
    this.revalidateTimeoutId = setTimeout(() => {
      this.revalidateTimeoutId = undefined;
      const { referenceId, type } = this.state;
      void this.loadSafeList(referenceId, type, false);
    }, WatchlistSafeListLinkComponent.REVALIDATE_DELAY_MS);
  };

  private loadSafeList = async (referenceId: string | null, type: WatchlistType, showLoader: boolean) => {
    if (referenceId == undefined || referenceId.trim().length == 0) {
      MessageUtil.error({
        summary: LanguageUtil.get({ id: 'pages.watchlist.title', defaultMessage: 'Watchlist' }),
        detail: LanguageUtil.get({
          id: 'pages.watchlist.safeListReferenceIdRequired',
          defaultMessage: 'Reference ID is required for Safe List operations!',
        }),
      });
      this.setState({ loading: false, rows: [] });
      return;
    }
    const currentToken = ++this.safeListLoadToken;
    if (showLoader) {
      this.setState({ loading: true });
    }
    try {
      const requestModel = this.getRequestModel();
      const searchResponse: WatchlistBaseModel[] =
        requestModel != undefined ? ((await this.watchlistService.searchMany(requestModel, type)) || []) : [];
      const rows = this.mapSafeListRows(searchResponse);
      if (currentToken !== this.safeListLoadToken) return;
      this.setState({ rows, selectedRows: [], loading: false });
    } catch (e) {
      MessageUtil.error({
        summary: LanguageUtil.get({ id: 'pages.watchlist.title', defaultMessage: 'Watchlist' }),
        detail: LanguageUtil.get({
          id: 'pages.watchlist.safeListViewError',
          defaultMessage: 'Failed to load Safe List!',
        }),
      });
      console.error(e);
      if (currentToken !== this.safeListLoadToken) return;
      this.setState({ loading: false, rows: [], selectedRows: [] });
    }
  };

  private getRequestModel = (): WatchlistIndividualRequest | WatchlistEntityRequest | WatchlistGeneralRequest | undefined => {
    const { router } = this.props;
    return WatchlistUtil.buildRequestFromSearchParams(new URLSearchParams(router.params.id));
  };

  private mapSafeListRows = (searchResponse: WatchlistBaseModel[]): SafeListTableRow[] => {
    return searchResponse
      .filter((item: WatchlistBaseModel) => item.isSafeListed === true)
      .sort((a: WatchlistBaseModel, b: WatchlistBaseModel) => b.score - a.score)
      .map((item: WatchlistBaseModel) => {
        return {
          consolidatedRecordId: item.record.id,
          record: item,
        };
      });
  };

  private onSelectionChange = (e: { value: SafeListTableRow[] }) => {
    this.setState({ selectedRows: e.value });
  };

  private onRowClickDetail = (row: SafeListTableRow) => {
    if (row.record == undefined || row.record == null) {
      return;
    }
    const request = this.getRequestModel();
    const data = row.record;
    const urlParams = new URLSearchParams();
    urlParams.set('type', ValueUtil.convertToStringFirstChar(data.record.recordType) || '');
    urlParams.set('recordId', data.record.id || '');
    urlParams.set('name', request?.name || '');
    urlParams.set('score', data.score?.toString() || '');
    urlParams.set('level', data.level?.toString() || '');
    urlParams.set('threshold', request?.threshold.toString() || '');
    urlParams.set('lists', request?.lists.toString() || '');
    urlParams.set('email', request?.email || '');
    urlParams.set('phone', request?.phone || '');
    if (request != undefined) {
      if ('dateOfBirth' in request) {
        urlParams.set('dateOfBirth', request.dateOfBirth || '');
        urlParams.set('citizenship', request.citizenship || '');
        urlParams.set('identification', request.identification || '');
      } else if ('dateOfRegistration' in request) {
        urlParams.set('dateOfRegistration', request.dateOfRegistration || '');
        urlParams.set('identifier', request.identifier || '');
      } else if ('date' in request) {
        urlParams.set('date', request.date || '');
        urlParams.set('id', request.id || '');
      }
      urlParams.set('referenceId', request.referenceId || '');
    }
    window.open(`/${NavigationUtil.getTenant()}/watchlist/detail/${urlParams.toString()}`, '_blank', 'noopener noreferrer');
  };

  private onRemove = async () => {
    const { selectedRows, referenceId } = this.state;
    if (referenceId == undefined || referenceId.trim().length == 0) {
      MessageUtil.error({
        summary: LanguageUtil.get({ id: 'pages.watchlist.title', defaultMessage: 'Watchlist' }),
        detail: LanguageUtil.get({
          id: 'pages.watchlist.safeListReferenceIdRequired',
          defaultMessage: 'Reference ID is required for Safe List operations!',
        }),
      });
      return;
    }
    const consolidatedRecordIds = selectedRows.map((row) => row.consolidatedRecordId).filter((id) => id != undefined && id.trim().length > 0);
    if (consolidatedRecordIds.length == 0) {
      MessageUtil.error({
        summary: LanguageUtil.get({ id: 'pages.watchlist.title', defaultMessage: 'Watchlist' }),
        detail: LanguageUtil.get({
          id: 'pages.watchlist.safeListRecordRequired',
          defaultMessage: 'Please select at least one record!',
        }),
      });
      return;
    }
    this.setState({ removeLoading: true });
    try {
      await this.watchlistService.removeSafeList({
        referenceId: referenceId,
        consolidatedRecordIds: consolidatedRecordIds,
      });
      const removedRecords = selectedRows
        .map((row) => row.record)
        .filter((record): record is WatchlistBaseModel => record != null)
        .map((record) => ({ ...record, isSafeListed: false }));
      MessageUtil.success({
        summary: LanguageUtil.get({ id: 'pages.watchlist.title', defaultMessage: 'Watchlist' }),
        detail: LanguageUtil.get({
          id: 'pages.watchlist.safeListRemoveSuccess',
          defaultMessage: 'Selected records removed from Safe List!',
        }),
      });
      this.setState({ removeLoading: false });
      SafeListPubSub.publish({ referenceId: referenceId, action: 'remove', records: removedRecords });
    } catch (e) {
      MessageUtil.error({
        summary: LanguageUtil.get({ id: 'pages.watchlist.title', defaultMessage: 'Watchlist' }),
        detail: LanguageUtil.get({
          id: 'pages.watchlist.safeListRemoveError',
          defaultMessage: 'Failed to remove records from Safe List!',
        }),
      });
      console.error(e);
      this.setState({ removeLoading: false });
    }
  };
}

interface Props extends FormicaProps {}

class State {
  searchCriteriaVisible: boolean = false;
  date: string | undefined;
  name: string | undefined | null;
  referenceId: string | null = null;
  type: WatchlistType = 'General';
  request: WatchlistIndividualRequest | WatchlistEntityRequest | WatchlistGeneralRequest | undefined;
  loading: boolean = true;
  removeLoading: boolean = false;
  rows: SafeListTableRow[] = [];
  selectedRows: SafeListTableRow[] = [];
}

export default withFormica(WatchlistSafeListLinkComponent);
